// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gG","storyTimeline__item":"c-a_gH","storyTimeline__item_complete":"c-a_gJ","storyTimeline__item_withProgress":"c-a_gK"};